interface ActiveFiltersProps {
  filters: {
    publisher?: string;
    category?: string[];
    typePlan?: string[];
    status?: string[];
  };
}

export function ActiveFilters({ filters }: ActiveFiltersProps) {
  const hasAnyFilter =
    filters.publisher ||
    filters.category?.length ||
    filters.typePlan?.length ||
    filters.status?.length;

  if (!hasAnyFilter) return null;

  return (
    <div
      style={{
        marginTop: "12px",
        display: "flex",
        gap: "8px",
        flexWrap: "wrap",
      }}
    >
      {/* STATUS */}
      {filters.status?.length > 0 && (
        <FilterChip
          label={`Status API: ${filters.status.join(", ")}`}
        />
      )}

      {/* TYPE PLAN */}
      {filters.typePlan?.length > 0 && (
        <FilterChip
          label={`Type Plan: ${capitalizeList(filters.typePlan).join(", ")}`}
        />
      )}

      {/* CATEGORY */}
      {filters.category?.length > 0 && (
        <FilterChip
          label={`Category: ${filters.category.join(", ")}`}
        />
      )}

      {/* PUBLISHER */}
      {filters.publisher && (
        <FilterChip label={`Publisher: ${filters.publisher}`} />
      )}
    </div>
  );
}

/* CHIP STYLE */
function FilterChip({ label }: { label: string }) {
  return (
    <span
      style={{
        padding: "6px 14px",
        borderRadius: "999px",
        fontSize: "13px",
        background: "#60A5FA",
        color: "#000000",
        fontWeight: 500,
        whiteSpace: "nowrap",
      }}
    >
      {label}
    </span>
  );
}

/* helper biar Free / Prepaid lebih cakep */
function capitalizeList(items: string[]) {
  return items.map(
    (item) => item.charAt(0).toUpperCase() + item.slice(1)
  );
}
